import {defineAsyncComponent} from "vue";

const vSelect = defineAsyncComponent(() => import('vue-select'))
const Paginate = defineAsyncComponent(() => import('vuejs-paginate-next'))

export default [
    {name: 'v-select', component: vSelect},
    {name: 'paginate', component: Paginate},
]
